import {
  CREATE_PN_TEMPLATE,
  CREATE_PN_TEMPLATE_FAIL,
  CREATE_PN_TEMPLATE_SUCCESS,
  PN_TEMPLATE,
  PN_TEMPLATE_FAIL,
  PN_TEMPLATE_SUCCESS,
  REMOVE_PN_TEMPLATE,
  REMOVE_PN_TEMPLATE_FAIL,
  REMOVE_PN_TEMPLATE_SUCCESS,
  UPDATE_PN_TEMPLATE,
  UPDATE_PN_TEMPLATE_FAIL,
  UPDATE_PN_TEMPLATE_SUCCESS,
} from "./actionTypes";

export const progressNoteTempList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: PN_TEMPLATE,
  payload: { data, onSuccess, onError },
});

export const progressNoteTempListSuccess = (data = {}) => ({
  type: PN_TEMPLATE_SUCCESS,
  payload: data,
});

export const progressNoteTempListFail = (data = {}) => ({
  type: PN_TEMPLATE_FAIL,
  payload: data,
});

export const removeProgressNoteTempList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REMOVE_PN_TEMPLATE,
  payload: { data, onSuccess, onError },
});

export const removeProgressNoteTempListSuccess = (data = {}) => ({
  type: REMOVE_PN_TEMPLATE_SUCCESS,
  payload: data,
});

export const removeProgressNoteTempListFail = (data = {}) => ({
  type: REMOVE_PN_TEMPLATE_FAIL,
  payload: data,
});

export const createProgressNoteTemp = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: CREATE_PN_TEMPLATE,
  payload: { data, onSuccess, onError },
});

export const createProgressNoteTempSuccess = (data = {}) => ({
  type: CREATE_PN_TEMPLATE_SUCCESS,
  payload: data,
});

export const createProgressNoteTempFail = (data = {}) => ({
  type: CREATE_PN_TEMPLATE_FAIL,
  payload: data,
});

export const updateProgressNoteTemp = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_PN_TEMPLATE,
  payload: { data, onSuccess, onError },
});

export const updateProgressNoteTempSuccess = (data = {}) => ({
  type: UPDATE_PN_TEMPLATE_SUCCESS,
  payload: data,
});

export const updateProgressNoteTempFail = (data = {}) => ({
  type: UPDATE_PN_TEMPLATE_FAIL,
  payload: data,
});
